<template>
  <div :class="$style.container">
    <Dialpad
      :dial-buttons="true"
      @input="handleInput"
      @phone="callNumber(phoneType)"
      @mobile="callNumber(mobileType)"
    >
      <template #key>
        <button @click="toggleMode"><font-awesome-icon :icon="faSearch" /></button>
      </template>
    </Dialpad>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch'
import Dialpad from '@/components/shared/Dialpad'

const { mapState, mapActions } = createNamespacedHelpers('dialer')

export default {
  components: {
    Dialpad,
    FontAwesomeIcon
  },
  data () {
    return {
      faSearch,
      phoneType: 'JIMINNY.SOFTPHONE.PHONE',
      mobileType: 'JIMINNY.SOFTPHONE.MOBILE'
    }
  },
  computed: {
    ...mapState([
      'number'
    ])
  },
  methods: {
    ...mapActions([
      'setNumber',
      'toggleMode'
    ]),
    handleInput ({key}) {
      this.setNumber(this.number + key)
    },
    callNumber (type) {
      this.$router.push({
        path: 'phone-controller',
        query: {
          type: encodeURIComponent(type),
          phone: encodeURIComponent(this.number)
        }
      })
    }
  }
}
</script>

<style module lang="less" src="./DialpadContainer.less"></style>



// WEBPACK FOOTER //
// DialpadContainer.vue?5222d6fc